import { EinzaGraphiQLService } from "@/services/einzaGraphiQL"

import { checkPermissions } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"
import { monthTarget, yearTarget } from "../utils/salesVolumeForAdms"

export const queryAdmVolumeStats = {
  async admVolumeStats(_parent, args, context, _info) {
    const { admNumber, year } = args
    const { user } = context
    const yearToUse = year && year > 0 ? year : new Date().getFullYear()

    await checkPermissions({
      user,
      admNumber: admNumber,
      domainObject: DomainObjects.VOLUME,
      operation: Operations.READ,
    })

    const graphiQLQueryObject = [
      {
        method: "admStats: admStatsCompanyMadeProducts",
        variables: {
          admNumber: admNumber,
          year: yearToUse,
        },
        fields: [
          "year",
          "month",
          "literKiloYtd",
          "literKiloMtd",
          "literKiloMtdPreviousYear",
          "literKiloYtdPreviousYear",
        ],
      },
    ]

    const mappedQuery = EinzaGraphiQLService.formQuery(graphiQLQueryObject)
    const einzaResponse = (await EinzaGraphiQLService.getData(mappedQuery))?.data?.admStats

    if (!einzaResponse || einzaResponse?.length <= 0) {
      throw new Error("Data could not be retrieved")
    }

    const currentYearVolumeData = einzaResponse?.map(({ year, month, literKiloMtd, literKiloMtdPreviousYear }) => ({
      month: month,
      year: year,
      volume: literKiloMtd,
      volumeTarget: monthTarget(literKiloMtdPreviousYear),
    }))

    return {
      projection: yearTarget(einzaResponse[0]?.literKiloYtdPreviousYear),
      yearVolume: einzaResponse[0]?.literKiloYtd,
      monthlyVolume: currentYearVolumeData,
    }
  },
}
